import { gettext } from '@eventbrite/i18n';
import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import { useIsMobileDevice } from '@eventbrite/feature-detection';
import {
    HOLIDAY_COLLECTION_TO_SLUG_MAPPING,
    HOLIDAY_COLLECTIONS_TOUCHPOINT_IMAGES,
} from '../../constants';
import React from 'react';
import styles from './HolidayCollectionsTouchpoint.module.scss';

export const HolidayCollectionsTouchpoint = ({ collectionId }) => {
    const isMobile = useIsMobileDevice();

    if (!(collectionId in HOLIDAY_COLLECTION_TO_SLUG_MAPPING)) {
        return null;
    }

    const ctaLink = `/b/${HOLIDAY_COLLECTION_TO_SLUG_MAPPING[collectionId]}/holiday/`;

    const holidayTouchpointTitle = gettext(
        'You’ve got holiday hopes… We’ve got just the thing.',
    );
    const holidayTouchpointSubtitle = !isMobile
        ? gettext('From super cozy to crazy fun.')
        : null;
    const imageSrc =
        HOLIDAY_COLLECTIONS_TOUCHPOINT_IMAGES?.[
            isMobile ? 'imgMobile' : 'imgDesktop'
        ];

    const touchpointData = [
        {
            className: styles.holidayCollectionsTouchpointTitle,
            text: holidayTouchpointTitle,
        },
        {
            className: styles.holidayCollectionsTouchpointSubtitle,
            text: holidayTouchpointSubtitle,
        },
    ];

    return (
        <div className={styles.holidayCollectionsTouchpoint}>
            <div className={styles.holidayCollectionsTouchpointContainer}>
                <div
                    className={
                        styles.holidayCollectionsTouchpointImageTextContainer
                    }
                >
                    <img
                        className={
                            styles.holidayCollectionsTouchpointImageContainer
                        }
                        src={imageSrc}
                        alt="Holiday Touchpoint"
                    />
                    <div
                        className={
                            styles.holidayCollectionsTouchpointTextContainer
                        }
                        data-testid="holiday-collections-touchpoint-title-subtitle"
                    >
                        {touchpointData.map((item, index) => (
                            <Typography
                                key={index}
                                as="h2"
                                className={item.className}
                            >
                                {item.text}
                            </Typography>
                        ))}
                    </div>
                </div>
                <a
                    href={ctaLink}
                    data-heap-id="holiday_collections_touchpoint_click"
                >
                    <Button
                        className={styles.holidayCollectionsTouchpointButton}
                    >
                        <span
                            className={
                                styles.holidayCollectionsTouchpointButtonText
                            }
                        >
                            {gettext('Discover holiday events')}
                        </span>
                        <ArrowRightIcon
                            className={
                                styles.holidayCollectionsTouchpointArrowRight
                            }
                        />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default HolidayCollectionsTouchpoint;
